import {clsx} from 'clsx'
import type {JSX} from 'react'
import styles from '@/products/flexible-web-toolkit/layout/row.module.css'
import {backgroundThemes} from '../colors'
import type {
	BgColor,
	ContainerClassName,
	RowWidthType,
	MobileStackOrder,
} from './layout-common-types'

interface RowProps {
	className?: string
	bgColor?: BgColor
	containerClassName?: ContainerClassName
	rowWidthType?: RowWidthType
	mobileStackOrder?: MobileStackOrder
	fiftyFiftyRowGap?: boolean
	children?: React.ReactNode
}

export const Row = ({
	className = '',
	bgColor = 'none',
	containerClassName = 'container-wide',
	rowWidthType = 'full-width',
	children = null,
	mobileStackOrder = 'default',
	fiftyFiftyRowGap = false,
}: RowProps): JSX.Element => {
	const gapClass =
		rowWidthType === 'fifty-fifty' && fiftyFiftyRowGap
			? styles['fifty-fifty-gap']
			: ''

	return (
		<div className={clsx(className, backgroundThemes.get(bgColor))}>
			<div
				className={clsx(
					containerClassName,
					styles[rowWidthType],
					gapClass,
					clsx(
						mobileStackOrder === 'reverse'
							? `${styles['flex-reverse']}`
							: ``
					)
				)}
			>
				{children}
			</div>
		</div>
	)
}
